import { useAuth } from '../../../v2/hooks/useAuth';
import { useEffect, useState } from 'react';
import { fetchContent } from '../../../data/api/trcApi';
import Toast from '../../../utils/toastManager';
import TRC_FILE_TYPE from '../../constants/trcFileType';
import TRC_PAGE_CATEGORIES from '../../constants/trcCategories';
import MobileTopSectionWithFilter from '@/TRC/components/TopSections/mobileTopSectionWithFilter';
import TopSectionWithFilter from '@/TRC/components/TopSections/topSectionWithFilter';
import VideoGrid from './components/grid';

const getCreatedAtTime = item => {
	const time = new Date(item?.createdAt || item?.updatedAt || 0).getTime();
	return Number.isNaN(time) ? 0 : time;
};

const sortNewestFirst = contents =>
	[...(contents || [])].sort((a, b) => getCreatedAtTime(b) - getCreatedAtTime(a));

const TRCVideos = () => {
	const { isLoggedIn } = useAuth();

	const [trcVideos, setTrcVideos] = useState();

	useEffect(() => {
		async function fetchVideo() {
			try {
				const response = await fetchContent({ category: TRC_PAGE_CATEGORIES.VIDEOS });
				setTrcVideos(sortNewestFirst(response?.data));
			} catch (error) {
				Toast.error(error.message || 'Something went wrong');
			}
		}
		fetchVideo();
	}, []);

	return (
		<div className="d-flex flex-column gap-2">
			<MobileTopSectionWithFilter
				contents={trcVideos}
				setContents={setTrcVideos}
				category={TRC_PAGE_CATEGORIES.VIDEOS}
			/>
			<TopSectionWithFilter
				category={TRC_PAGE_CATEGORIES.VIDEOS}
				contents={trcVideos}
				setContents={setTrcVideos}
				contentType={TRC_FILE_TYPE.VIDEO}
			/>
			<VideoGrid trcVideos={trcVideos || []} isLoggedIn={isLoggedIn} />
		</div>
	);
};

export default TRCVideos;
